import { render } from "./AccountingPeroidsPage.vue?vue&type=template&id=87ef7b5a&scoped=true"
import script from "./AccountingPeroidsPage.vue?vue&type=script&lang=js"
export * from "./AccountingPeroidsPage.vue?vue&type=script&lang=js"

import "./AccountingPeroidsPage.vue?vue&type=style&index=0&id=87ef7b5a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ef7b5a"]])

export default __exports__